<template>
  <div class="mask-layer">
    <div class="loading-spinner">
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.mask-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999999;
}

.loading-spinner {
    /* 自定义加载动画样式 */
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    width: 450px;
    height: 620px;
    background: url(@/assets/good.png) no-repeat center;
    background-size: 100% 100%;
    animation: scaleUp 1s forwards; /* 应用动画 */
  }
  .loading-spinner span {
    position: absolute;
    top: 430px;
    left: 50%;
    transform: translate(-50%);
    min-height: 89px;
    width: 68%;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 37px;
    color: #000000;
    line-height: 53px;
    /* text-shadow: 1px 3px 4px #c32f0f; */
    text-align: center;
  }
@keyframes scaleUp {
  0% {
    transform: translate(-50%, -50%) scale(0); /* 开始时缩放为0 */
  }
  100% {
    transform: translate(-50%, -50%) scale(1.2); /* 结束时缩放为1 */
  }
}
</style>
